import { render } from "./Lavels.vue?vue&type=template&id=4a0e374a"
import script from "./Lavels.vue?vue&type=script&lang=js"
export * from "./Lavels.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__